import { ABFilter, ABFilterBar } from '../lib/ab/filter-bar';
import { ABObjectCount } from '../lib/ab/widgets-admin';
import { EPaymentIntentAdminView, ePaymentIntentsGetAdminView } from '../lib/mdl/e-payment-intent';
import { UITableDefinition, UITable } from '../lib/ui/component/table';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIViewSpec } from '../lib/ui/view';
import { YArrayDataSource } from '../lib/y/data-source';
import { xavis_experiments } from '../lib/y/debug';
import { $time } from '../lib/y/time';

function filterIntents(intents: EPaymentIntentAdminView[], filters: ABFilter[]) {
    for(const f of filters) {
        if(f.key == 'country')
            intents = intents.filter(u => f.value.includes(u.country));
        else if(f.key == 'account_status')
            intents = intents//.filter(u => f.value.includes(u.account_status));
        else if(f.key == 'kind')
            intents = intents//.filter(u => f.value.includes(u.subscription_kind));
        else if(f.key == 'test_mode')
            intents = intents.filter(i => f.value.includes(i.is_test ? 'true' : 'false'));
    }

    return intents;
}

export class AdminIntentsScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const doSearch = () => {
            let intents = filterIntents(all_intents, filters.filters);

            intents = filter_bar.search_input!.filterArray(intents, (u, w) => {
                if(u.name.toLowerCase().includes(w)) return true;
                if(u.kind.toLowerCase().includes(w)) return true;
                if(u.email.toLowerCase().includes(w)) return true;
                if(u.status.includes(w)) return true;
                if(u.provider.toLowerCase().includes(w)) return true;
                return false;
            });

            count.number = intents.length;
            source.data = intents;
        }

        const doRefresh = async () => {
            all_intents = await ePaymentIntentsGetAdminView();
            doSearch();
        }

        const count = new ABObjectCount('payments');

        const filter_bar = new ABFilterBar({
            on_refresh: doRefresh,
            on_filter: doSearch,
            on_search: doSearch,
            right_content: [count],
            no_header: true
        });

        const filters = filter_bar.filters;
        filters.addCity();
        if(xavis_experiments) {
            filters.addIsTest();
            filters.add('test_mode', 'Test mode', ['false'], 'No test');
        }

        const def = new UITableDefinition<EPaymentIntentAdminView>();
        def.addValue(i => i.name, { title: 'Name', width: 160 });
        def.addValue(i => i.email, { title: 'Email', width: 160 });
        def.addValue(i => i.kind, { title: 'Type', width: 160 });
        def.addValue(i => i.status, { title: 'Status', width: 160 });
        def.addValue(i => i.provider, { title: 'Provider', width: 160 });
        def.addValue(i => i.amount, $fmt.CURRENCY, { title: 'Amount', width: 160 });
        def.addValue(i => $time(i.created_at), $fmt.DATE('d MMM yyyy HH:mm'), { title: 'Created at', width: -120 });
        def.addValue(i => i.country, { title: 'Country', width: 100 });

        // def.addButtons([
        //     { icon: UIIcon.PENCIL, tooltip: 'Edit', action: item => {
        //         $location.push({ 'user', item.id });
        //     }},
        //     { icon: UIIcon.EYE, tooltip: 'View as user', link: u => 'https://abundolive.se?as_user='+u.view_as_user_token }
        // ], { width: -62 });

        def.preference_prefix = 'payment_intents';

        const source = new YArrayDataSource<EPaymentIntentAdminView>();

        let all_intents = await ePaymentIntentsGetAdminView();

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-wide', [
                filter_bar,
                new UITable(def, source),
            ]))
        ]);

        doSearch();
    }
}
